import { NavigationCommand } from '../interfaces/route/RouteEntry';
import { ResultEntry } from '../interfaces/search/ResultEntry';
import { SpeedProfile } from '../interfaces/state-events/RoutingRequest';
import { IConfig } from './IConfig';

const config = {
	apiKey: '/UPZjd3W6GoUfx5mrGtMCHeiKD1gcNZBAnw05tgHxDs=',

	rootUrl: 'https://www.yellowmap.de',

	channel: 'CashPoolV2',

	apiCall(apiKey: string): string {
		const url = this.rootUrl;
		return `${url}/api_rst/api/loader?apiKey=${apiKey}&libraries=enterprise-3`;
	},

	authorization: 'YM CashPool:dXBjhUAP4mLPv6veuEXWzw==',

	// Fallback internationalization and for web service calls
	defaultIsoLocale: 'de-DE',
	defaultCountryCode: 'DE',

	// TODO @FutureDeveloper currently not in use. This configuration will be used for internationalization.
	isoLocales: ['de-DE', 'en-US'],

	responsive: {
		mobile: { min: 0, max: 767 },
		tablet: { min: 768, max: 1024 },
		smallDesktop: { min: 1024, max: 1366 },
		largeDesktop: { min: 1366, max: Infinity }
	},

	history: true,

	searchRequest: {
		top: 100,
		topVisible: 20,
		branches: ['GACP'],

		initialGeolocation: false
	},

	filters: [
		{
			label: 'additionalCB',
			branches: ['GACP', 'EHSB']
		},
		{
			label: 'publicDeg',
			branches: ['GACP'],

			// explicitely remove any non-public branch
			dataFilters: '!CPxDEGxNPB'
		}
	],

	defaultMarkerSize: {
		activeIcon: [66, 66],
		inactiveIcon: [56, 56],

		// the anchor is defined by the active-icon size
		iconAnchor: [33, 66],

		sliderWidth: 400
	},

	// first in, first out
	icons: [
		{
			highlightMarker: {
				src: 'images/Cashback-Pin.svg'
			},
			branches: ['EHSB']
		},
		{
			highlightMarker: {
				src: 'images/CashPool-Pin_Alert.svg'
			},
			contentOffset: { top: 4 },
			branches: ['CPxDEGxNPB']
		},
		{
			highlightMarker: {
				src: 'images/Cashpool-Pin.svg'
			},
			branches: []
		}
	],

	searchIcon: {
		iconUrl: 'images/location.svg',
		iconSize: [30, 30]
	},

	map: {
		offset: {
			top: 20,
			right: 20,
			bottom: 20,
			left: 20
		}
	},

	autocomplete: {
		locales: ['de']
	},

	routing: {
		enabled: true
	},

	resultsView: {
		scrolling: {
			autoScroll: false,
			sizes: []
		},
		onDetails: {
			hidesAt: ['tablet']
		},
		onRouting: {
			hidesAt: ['tablet']
		}
	},

	detailsView: {
		vcard: {
			enabled: true,
			branchCode: '',
			redirectTarget: '_blank',
			redirectHref: (params: ResultEntry): string => {
				let result =
					`BEGIN:VCARD\n` +
					`VERSION:2.1\n` +
					`FN;CHARSET=UTF-8:${params.address.name}\n` +
					`N;CHARSET=UTF-8:${params.address.name};${params.address.nameAddon2 || ''}\n` +
					`ADR;HOME;CHARSET=UTF-8:;;${params.address.streetNo};${params.address.city};;${params.address.zip};Deutschland\n`;

				if (config.detailsView.contact.mobile && params.contact.mobile.length) {
					result += `TEL;HOME;CELL:${params.contact.mobile[0]}\n`;
				}
				if (config.detailsView.contact.tel && params.contact.tel.length) {
					result += `TEL;HOME;VOICE:${params.contact.tel[0]}\n`;
				}
				if (config.detailsView.contact.fax && params.contact.fax.length) {
					result += `TEL;HOME;FAX:${params.contact.fax[0]}\n`;
				}
				if (config.detailsView.contact.email && params.contact.email.length) {
					result += `EMAIL;INTERNET:${params.contact.email[0]}\n`;
				}
				if (config.detailsView.contact.url && params.contact.url.length) {
					result += `URL;WORK:${params.contact.url[0]}\n`;
				}

				result += `END:VCARD\n`;
				return 'data:text/vcard;base64,' + btoa(result);
			},
			redirectByBranchCode: {}
		},

		infoWhitelist: [],

		infoIcons: [],

		businessHours: {
			enabled: true,
			showIsOpen: true
		},
		contact: {
			get enabled(): boolean {
				return this.tel || this.mobile || this.fax;
			},
			tel: true,
			mobile: true,
			fax: true,

			get additionalContact(): boolean {
				return this.email || this.url;
			},
			email: true,
			url: false
		}
	},

	routingView: {
		speedProfile: {
			[SpeedProfile.Car]: 'directions_car',
			[SpeedProfile.Bicycle]: 'directions_bike',
			[SpeedProfile.Pedestrian]: 'directions_walk'
		},
		navigationIcon: {
			[NavigationCommand.None]: 'images/arrow.svg',
			[NavigationCommand.Start]: 'images/arrow.svg',
			[NavigationCommand.Forward]: 'images/Geradeaus.svg',
			[NavigationCommand.Right]: 'images/Rechts.svg',
			[NavigationCommand.Left]: 'images/Links.svg',
			[NavigationCommand.HalfRight]: 'images/Halb Rechts.svg',
			[NavigationCommand.HalfLeft]: 'images/Halb Links.svg',
			[NavigationCommand.CircleOut]: 'images/Cycle Out.svg',
			[NavigationCommand.CircleIn]: 'images/Cycle In.svg',
			[NavigationCommand.End]: 'images/arrow.svg'
		}
	}
} as IConfig<(data: ResultEntry) => string>;

export default config;
